:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font: inherit;
  margin: 0;
  padding: 0;
  color: inherit;
}

:host {
  display: grid;
  grid-template-rows: 1fr max-content;
}

:host(.ch-chat--additional-content) {
  grid-template-rows: 1fr max-content max-content;
}

ch-chat-lit {
  display: contents;
}

.assistant-content,
.user-content {
  contain: paint;
}

img {
  display: block;
  max-inline-size: 100%;
}

.assistant-loading {
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
}

::part(code-block__header) {
  display: grid;
  grid-template-columns: 1fr max-content;
}

.contents {
  display: contents;
}

.file-container {
  display: block;
}

.sources-container {
  display: flex;
  flex-wrap: wrap;
}

.files-container,
.sources-container {
  margin: 0;
  padding: 0;
}

.send-input {
  grid-template: "ch-chat-send-input-before" max-content "ch-edit-content" 1fr "ch-chat-send-input-after" max-content/1fr;
}

.send-input-before {
  grid-area: ch-chat-send-input-before;
}

.send-input-after {
  grid-area: ch-chat-send-input-after;
}

.send-container,
.additional-content-container {
  display: grid;
}

.ch-virtual-scroller--content-loaded > ch-chat-lit > ch-smart-grid-cell:not([data-did-load]) {
  position: absolute;
  pointer-events: none;
  visibility: hidden;
}

.spinner-loading {
  animation: infinite-rotate 0.875s linear 0s infinite;
}

@keyframes infinite-rotate {
  100% {
    transform: rotate(1turn);
  }
}
@keyframes gx-skeleton-load {
  to {
    transform: translateX(192%);
  }
}
.processing-animation {
  content: "";
  margin-inline-start: auto;
  display: block;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" fill="%23939498"/></svg>'), url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" fill="%23939498"/></svg>'), url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" fill="%23939498"/></svg>');
  inline-size: 20px;
  block-size: 16px;
  background-position: left, center, right;
  background-size: 4px, 4px, 4px;
  background-repeat: no-repeat;
  animation: ellipsis 1s infinite linear;
}

@keyframes ellipsis {
  0% {
    background-size: 6px, 4px, 4px;
  }
  25% {
    background-size: 4px, 6px, 4px;
  }
  50% {
    background-size: 4px, 4px, 6px;
  }
  75% {
    background-size: 4px, 6px, 4px;
  }
  100% {
    background-size: 6px, 4px, 4px;
  }
}